import React from 'react';
import './ErrorHandler.css';

const ErrorHandler = ({ errorCode, errorMessage }) => {
    const getErrorMessage = () => {
        switch (errorCode) {
            case 404:
            case "404":
                return 'Page not found.';
            case 403:
            case "403":
                return 'You have reached your limit. Please upgrade your plan.';
            case 500:
            case "500":
                return 'Internal server error.';
            case 'ERR_NETWORK':
                return 'Unable to connect to the server.<br /> Please check your internet connection and try again.';
            case 'ERR_CONNECTION_REFUSED':
                return 'Unable to connect to the server.<br /> Please check your internet connection and try again.';
            default:
                return 'An unexpected error occurred.';
        }
    };

    return (
        <div className="error-handler">
            <div className="error-icon">
                ?
            </div>
            <p dangerouslySetInnerHTML={{ __html: errorMessage || getErrorMessage() }}></p>
        </div>
    );
};

export default ErrorHandler;
